import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import PriceComponentsTable from "./PriceComponentsTable"
import { useTranslation } from "react-i18next"
import RelatedPriceComponentsTable from "./RelatedPriceComponentsTable"
import { useParams } from "react-router-dom"

export default function PriceComponentsList() {

  const { t } = useTranslation()

  const {employeeId} = useParams()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Price Components")} />
        {!employeeId && <PriceComponentsTable />}
        {employeeId && <RelatedPriceComponentsTable relatedId={employeeId} type={"employees"} />}

      </div>
    </div>
  )
}
